// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"SearchInput_searchBar__2tsx4","visuallyHidden":"SearchInput_visuallyHidden__1Pmth"};